module.exports = __webpack_public_path__ + "img/03n@2x.ad789581.svg";